import { PostHogProvider } from "posthog-js/react";

import type { PostHogConfig } from "posthog-js";
import type React from "react";

interface PostHogWrapperProps {
  children: React.ReactNode;
}

export function PostHogWrapper({ children }: PostHogWrapperProps) {
  const apiKey = import.meta.env.VITE_POSTHOG_KEY;
  const posthogOptions: Partial<PostHogConfig> = {
    api_host: import.meta.env.VITE_POSTHOG_HOST || "https://eu.i.posthog.com",
    capture_pageleave: true,
    capture_pageview: true,
  };

  // PostHog sin key no aporta telemetría y ensucia cada pantalla con warnings. Staging puede
  // dejarlo deliberadamente desactivado; en ese caso el provider no debe montarse.
  if (!apiKey) return children;

  return (
    <PostHogProvider apiKey={apiKey} options={posthogOptions}>
      {children}
    </PostHogProvider>
  );
}
